module.exports = __webpack_public_path__ + "static/media/logo-montesaltos.0a03de0f.png";